import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    padding: '24px',
    border: '1px solid',
    borderColor: 'common.border',
    flex: 1,
    borderRadius: '8px',
  },
  customLoadingContainer: {
    position: 'fixed',
    height: '100vh',
    left: 0,
    zIndex: 999,
  },
  title: {
    fontSize: 18,
    color: 'grey.800',
    fontWeight: '600',
    mb: '16px',
  },
  metadataContainer: {
    paddingTop: '16px',
    marginTop: '16px',
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'common.border',
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  labelContainer: {
    position: 'relative',
  },
  label: {
    fontSize: 16,
    color: 'grey.800',
    lineHeight: '24px',
  },
  value: {
    fontWeight: '700',
  },
  total: {
    color: 'primary.main',
  },
  checkboxLabel: {
    fontSize: 14,
  },
  checkboxContainer: {
    mt: '14px',
  },
  buttonContainer: {
    mt: '14px',
  },
  closeIcon: {
    color: 'common.grey350',
    backgroundColor: 'common.lightBackgroundColor',
  },
  closeContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
